const parseTitle = (title) => {
  let newTitle = title;
  if (title.includes('**')) {
    newTitle = title.replace(/\**/g, '');
  }
  if (title.includes('_')) {
    newTitle = title.replace(/_/g, '');
  }

  return newTitle.trim();
};

export default parseTitle;
